import React, {useEffect, useState} from 'react'
import {
    CButton,
    CCol,
    CContainer,
    CForm,
    CFormFeedback,
    CFormInput,
    CFormLabel, CFormSelect,
    CLoadingButton,
    CModal,
    CModalBody,
    CModalHeader,
    CModalTitle,
    CRow
} from "@coreui/react-pro";
import {BiEnvelope} from "react-icons/bi";
import {BsTelephone} from "react-icons/bs";
import {useAddGov,} from "../../hooks/admin/adminApiHooks";
import {Link} from "react-router-dom";

import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {AddGovSchema} from "../../form-schema/admin-form-schema/createAdminSchema";
import {fail_notify, success_notify} from "../../constant";
import {useGetAllEmployers} from "../../hooks/employer/employerApiHooks";

const Government = () => {
    const [agenciesData, setAgenciesData] = useState([])
    const [visible, setVisible] = useState(false)
    const {isLoading, isSuccess, data, isError, error, mutate} = useAddGov()
    const [limit, setLimit] = useState(10)
    let {data: agencies, refetch} = useGetAllEmployers(limit)

    useEffect(() => {
        if (isSuccess) {
            success_notify('Successful')
            setVisible(false)
        }

        if (isError) {
            fail_notify(error?.response?.data?.message)
        }

        setAgenciesData(agencies?.data?.data?.items?.filter((item)=>{
            return !item?.institutionsType
        }).map((item, index) => {
            if (item?.institutionsType){
               return
            }else {
                return {
                    id: index,
                    user: [item?.name, item?.logoUrl],
                    phoneNumber: item.phoneNumber,
                    email: item.email,
                    registered: item?.createdAt.substring(0, 10),
                    action: item?.stakeholderUuid
                }
            }
        }))

    }, [isLoading, isSuccess, data, isError, error, mutate, agencies.isSuccess])

    useEffect(() => {
        refetch()
    }, [limit]);

    const {
        register,
        handleSubmit,
        formState: {errors}
    } = useForm({
        resolver: yupResolver(AddGovSchema),
    })
    const handleSignUp = (data) => {
        mutate(data)
    }

    const convertToDate = (date) => {
        const _date = new Date(Date.parse(date))
        return _date.toLocaleDateString()
    }

    const convertUserDisplay = (user) => {
        return (
            <div className="d-flex flex-row justify-content-start align-items-center p-0">
                {/*<CImage src={DummyProfilePic} alt="Profile" style={{*/}
                {/*    width: '32px',*/}
                {/*    height: '32px',*/}
                {/*    marginRight: '10px',*/}
                {/*    borderRadius: '50%',*/}
                {/*}}/>*/}
                <p style={{marginBottom: "0"}}><b>{user}</b></p>
            </div>
        )
    }

    const convertAction = (action) => {
        return <Link to={`/admin/employer/${action}`}>
            <button className="btn btn-sm text-white btn-primary">View</button>
        </Link>
    }


    return (
        <CContainer>
            <div className="d-flex flex-row justify-content-between align-items-center">
                <div>
                    <h5>Government Agencies</h5>
                </div>
                <div className="d-flex flex-row justify-content-center align-items-center">
                    <CButton onClick={() => setVisible(!visible)} className="text-white px-5 users-action-buttons">+ ADD GOV</CButton>
                </div>
            </div>
            {/*{!isMobile && <div>
                <div className="d-flex flex-row justify-content-end align-items-center px-1">
                    <p
                        className="text-primary cursor-pointer"

                    >Clear all</p>
                </div>
                <CRow>
                    <CCol md={4}>
                        <CFormLabel htmlFor="name" className="m-1 label">Name</CFormLabel>
                        <CFormInput type="text" id="name"
                                    aria-describedby="searchByText"

                                    className="rounded-0"
                        />
                    </CCol>
                    <CCol md={4}>
                        <CFormLabel htmlFor="email" className="m-1 label">Email</CFormLabel>
                        <CFormInput type="text" id="email"
                                    aria-describedby="searchByEmail"

                                    className="rounded-0"
                        />
                    </CCol>
                </CRow>
            </div>}*/}
            <CRow className="mt-3 mb-5">
                <CCol md={12}>
                    <table className="table border-0" id="reports-table">
                        <thead className="thead-inverse">
                        <tr className="bg-transparent text-primary">
                            <th>User</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Registered</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            agenciesData?.map((item, index) => {
                                return <tr key={index}>
                                    <td>{convertUserDisplay(item.user)}</td>
                                    <td><BsTelephone/> {item.phoneNumber}</td>
                                    <td><BiEnvelope/> {item.email}</td>
                                    <td>{convertToDate(item.registered)}</td>
                                    <td>{convertAction(item.action)}</td>
                                </tr>
                            })
                        }
                        </tbody>
                    </table>
                    {agenciesData?.length > 10 && <div className={"d-flex flex-row gap-3 w-23"}>
                        <div className={"m-2"}>Show</div>
                        <CFormSelect
                            aria-label="Default select example"
                            options={[
                                {label: '10', value: '10'},
                                {label: '25', value: '25'},
                                {label: '100', value: '100'},
                                {label: '200', value: '200'}
                            ]}
                            onChange={(e) => setLimit(e.target.value)}
                        />
                        <div className={"m-2"}>Entries</div>
                    </div>}
                </CCol>
            </CRow>
            <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                alignment="center"
            >
                <CModalHeader onClose={() => setVisible(false)}>
                    <CModalTitle id="LiveDemoExampleLabel">Add Government Agency</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <CForm noValidate className="needs-validation" onSubmit={handleSubmit(handleSignUp)}>
                        <div className="w-100">
                            <div>
                                <CFormLabel htmlFor="searchBy" className="m-1 label">Name</CFormLabel>
                                <CFormInput type="text" id="gov_name"
                                            placeholder="Ministry of Works"
                                            {...register('gov_name')}
                                            invalid={!!errors.gov_name}
                                />
                                <CFormFeedback invalid={!!errors.gov_name}>
                                    {errors.gov_name?.message}
                                </CFormFeedback>
                            </div>
                            <div className="">
                                <CFormLabel htmlFor="searchBy" className="m-1 label">Email</CFormLabel>
                                <CFormInput type="email" id="email"
                                            placeholder="info@ministry.gov.ng"
                                            {...register('email')}
                                            invalid={!!errors.email}
                                />
                                <CFormFeedback invalid={!!errors.email}>
                                {errors.email?.message}
                            </CFormFeedback>
                            </div>
                            <div>
                                <CFormLabel htmlFor="searchBy" className="m-1 label">Phone Number</CFormLabel>
                                <CFormInput type="text" id="phoneNumber"
                                            placeholder="09067898765"
                                            {...register('phoneNumber')}
                                            invalid={!!errors.phoneNumber}
                                />
                                <CFormFeedback invalid={!!errors.phoneNumber}>
                                {errors.phoneNumber?.message}
                            </CFormFeedback>
                            </div>
                            <br/>
                            <div className="text-center">
                                <CLoadingButton
                                    type="submit"
                                    className="reg-btn px-4 w-50 py-2 text-center"
                                    disabled={isLoading}
                                    loading={isLoading}
                                >
                                    Submit
                                </CLoadingButton>
                            </div>
                        </div>
                    </CForm>
                </CModalBody>

            </CModal>
        </CContainer>
    )
}

export default Government
